"use client";

import React from "react";
import styles from "./stay-updated.module.scss";
import Image from "next/image";
import icon from "@public/icon_white.png";
import PagePositioner from "@/components/layout/page-positioner/page-positioner";
import EmailSubscribe from "@/components/layout/email-subscribe/email-subscribe";

const StayUpdated = () => {
  return (
    <div className={styles.container}>
      <div className={styles.containerBackground} />
      <PagePositioner>
        <div className={styles.block}>
          <div className={styles.col}>
            <div>
              <div className={styles.logo}>
                <Image src={icon} alt={"blessnet-logo"} />
              </div>
              <div className={styles.subheader}>
                Stay ahead of
                <br /> the curve
              </div>
              <div className={styles.paragraph}>
                Subscribe below and be the <br />
                first to know about the latest updates.
              </div>
              <EmailSubscribe />
            </div>
          </div>
        </div>
      </PagePositioner>
    </div>
  );
};

export default StayUpdated;
